import { PROFILES } from "@/enum/Profiles";

import { userSettings, saveUserSettings } from "@/globals/userSettings";
import renderTools from "@/views/menu/renderTools";
import disableContrast from "./disableContrast";
import selectButtons from "./selectButtons";

export default function disableProfile(profile: string, $menu: HTMLElement) {
  const profileConfig = PROFILES[profile];
  if (!profileConfig) return;
  disableContrast();
  userSettings.states.contrast = false;
  profileConfig.tools.forEach((tool: string) => {
    if (tool === 'font-size') {
      // Reset numeric font size multiplier
      userSettings.states.fontSize = 1;
    } else {
      userSettings.states[tool] = false;
    }
    saveUserSettings();
  });
  renderTools();
  selectButtons($menu);

  // Mirror enableProfile: refresh the "Adjust Font Size" percentage span so it
  // reflects the reset to 100%. Without this, renderTools / adjustFontSize have
  // already restored the page text, but the on-screen counter still reads e.g.
  // "120%" until the user clicks +/-.
  const newFontSize = Number(userSettings.states.fontSize) || 1;
  const amountElement = $menu.querySelector(".cya11y-amount");
  if (amountElement) {
    amountElement.textContent = `${(newFontSize * 100).toFixed(0)}%`;
  }
}
